import React, { useState, useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import '../assets/css/homepage.css'
import pausewave from '../assets/images/pause.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Hangup, Resume, Pause, Logout, CreateTicket, FetchTicket, MakeManualcall, AgentFetch } from '../redux/apicalling/dispatchfunction';
import * as JsSIP from 'jssip';
import { useNavigate } from 'react-router-dom';
import ringtoneSrc from '../assets/audio/ringtone.wav'
import rightillu from '../assets/images/homepagerightimg.avif'
import favicon from '../assets/images/favicon.png'
import {

    faPhone,
    faArrowLeft

} from '@fortawesome/free-solid-svg-icons';
import Comtemplete from './comtemplete';
import CallLog from './calllogpage';
import Dialpad from './dialpad';
import Webphone from '../components/webphone';
import BottomNavigator from '../components/bottomnavigation';
import Incomingcallscreen from '../components/incomingcallpage';
import { setSession } from '../redux/RTCsession/sessionAction';
import { setCallerInsights } from '../redux/callerinsights/insightaction';
import { setcallstatus } from '../redux/callstatus/callstatusaction';
import { rtcprocess, rtcfailed, rtcended, setshowcalllogpage,setagentstatus } from '../redux/backgroundpermission/permission-action';
import Disposcreen from './dispopage';
function formatCallDuration(durationInSeconds) {
    const minutes = Math.floor(durationInSeconds / 60).toString().padStart(2, '0');
    const seconds = (durationInSeconds % 60).toString().padStart(2, '0');
    return `${minutes}:${seconds}`;
}
function Homepage() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user_name1 = localStorage.getItem("username")
    const [tenantid, setTenantId] = useState("")
    const [useremail, setUserEmail] = useState("")
    const [entity_type, setEntityType] = useState("")
    const [userid, setUserId] = useState("")
    const [entity_id, setEntityId] = useState("")

    const [response, setResponse] = useState("")
    const [phone, setPhone] = useState("");
    const [callStatus, setCallStatus] = useState('On Call1'); // Initialize as 'idle'
    const [pause, setPause] = useState(false);
    const [awayOptionsOpen, setAwayOptionsOpen] = useState(false); // New state variable
    const [badge, setBadge] = useState('Offline'); // Initialize with the default status
    const [isDispositionSelected, setIsDispositionSelected] = useState(false);
    const [webphone, setWebphone] = useState(false);

    const [callername, setcallername] = useState('');
    const [callernumber, setCallernumber] = useState("");
    // const [profileId,setProfileId] = useState('');
    // const [callToken,setCallToken] = useState('');
    // const [agentId,setAgentId] = useState('');
const profileIdRef = useRef('');
const callTokenRef = useRef('');
const agentIdRef = useRef('');



    const [leadname, setLeadName] = useState("Unknown Name");//incomingcall
    const [station, setStation] = useState("");
    const [incomingscreen, setIncomingscreen] = useState(false);
    const [inboundcall, setInboundcall] = useState(false); // show + and eye icon in IB call
    const [incominganswer, setIncominganswer] = useState(false); //set to session  event
    const [sipconnected,setSipconnected]=useState(false);
    const [sipOptions, setsipOptions] = useState({
        mediaConstraints: {
            audio: true,
            video: false,
        },
    })
    const [callDuration, setCallDuration] = useState(0);
    const [isMuted, setIsMuted] = useState(false);
    const [isOnHold, setIsOnHold] = useState(false);
    const [callStartTime, setCallStartTime] = useState(null);
    const [incomingdetails, setIncomingdetails] = useState(false);
    const [dispositionStatusOptions, setDispositionStatusOptions] = useState("")
    const [callNotes, setCallNotes] = useState('');
    const [dispositionStatus, setDispositionStatus] = useState('');
    const [incomingdata, setIncomingdata] = useState("")
    const [inboundnumber, setInboundnumber] = useState("")
    //Inbound lead detail
    const [ibleadowner, setIbLeadOwner] = useState("")
    const [ibleaddate, setIbLeadDate] = useState("")
    const [ibleadid, setIbLeadId] = useState("")
    const [starttimer, setStarttimer] = useState(false)
    const [callended, setCallended] = useState(true)
    const [crmownername, setcrmownername] = useState('')

    const ringtoneRef = useRef(new Audio(ringtoneSrc));
    let station2 = localStorage.getItem('station')
    const backgroundstate = useSelector((state) => state.bgpermission)
    const [showDialpad, setShowDialpad] = useState(false);

    const [iconType, setIconType] = useState(faPhone); // Manage the icon type
    const [showCallLog, setShowCallLog] = useState(backgroundstate.setshowcalllogpage); // Initial state from backgroundstate
    const agentavailable_state = JSON.parse(localStorage.getItem('agentstatus'))
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const campaign = localStorage.getItem('selectedcampaign')

    useEffect(() => {

        const intervalId = setInterval(() => {
            fetchliveagent()
            setIsOnline(navigator.onLine);
            if (navigator.onLine == false) {

                toast.error('Network Disconnected')
            }
        }, 2000);


        return () => clearInterval(intervalId);
    }, []);

    const fetchliveagent = () => {
        const liveagentpayload = {
            user: user_name1
        }
        dispatch(AgentFetch(liveagentpayload)).then((liveagentres) => {
            if (liveagentres.data.data.length > 0) {
                if (liveagentres.data.data[0].status == "READY") {
                    // localStorage.setItem('livecall', false)
                    dispatch(setagentstatus(false))
                }
              
            } else {
                forcelogout()
            }

        }).catch((err) => {
            return err
        })
    }
    useEffect(() => {
        setShowCallLog(backgroundstate.setshowcalllogpage)

    }, [backgroundstate.setshowcalllogpage])

    useEffect(() => {
        if (showCallLog) {
            setIconType(faPhone)
        }
    }, [showCallLog])


    const toggleDialpad = () => {


        if (showDialpad) {
            dispatch(setshowcalllogpage(true))
            setIconType(faPhone)

        } else {
            dispatch(setshowcalllogpage(false))
            setIconType(faArrowLeft)
        }

        // setIconType(showDialpad ? faPhone : faArrowLeft);

        setShowDialpad(!showDialpad);
    };





    let webrtc_status = backgroundstate.setwebrtcstatus
    useEffect(() => {
        if (webrtc_status && agentavailable_state) {

            webrtc()

        }
    }, [webrtc_status])





    // const openDialpad = () => {
    //     setShowDialpad(true);
    // };

    // const closeDialpad = () => {
    //     setShowDialpad(false);

    // };

    const handleDial = (number) => {
        response.sendDTMF(number);

    };


    const unregisterWebRTC = () => {
        if (phone) {
            phone.unregister(); // Unregister from the SIP server
            localStorage.setItem('resume', JSON.stringify(false))
        }
    };

    const toggleMute = () => {
        setIsMuted(!isMuted);

        if (response) {
            if (isMuted) {
                response.unmute();
                setCallStatus('oncall');
            } else {
                response.mute();
                setCallStatus('mute');
            }
        }
    };

    const forcelogout = () => {
        localStorage.removeItem('login');
        localStorage.removeItem('hanguppayload');
        localStorage.removeItem('resume');
        localStorage.removeItem('agentstatus');
        localStorage.removeItem('config');
        localStorage.removeItem('username');
        localStorage.removeItem('apinfo');
        localStorage.removeItem('token');
        localStorage.removeItem('callstatus');
        localStorage.removeItem('queuelogin');
        
        localStorage.removeItem('entititytype');
        localStorage.removeItem('station');
        localStorage.removeItem('selectedcampaign')
        // window.location.href = `/`;
        navigate('/')

    }

    const toggleHold = () => {
        setIsOnHold(!isOnHold);

        if (response) {
            if (isOnHold) {
                response.unhold();
                setCallStatus('oncall');
            } else {
                response.hold();
                setCallStatus('hold');
            }
        }
    };

    const crmaddlead = () => {

    };
    const crmviewlead = () => {
    };
    const handleCallNotesChange = (event) => {
        setCallNotes(event.target.value);
    };
    const handleDispositionStatusChange = (event) => {
        const selectedStatus = event.target.value;
        setDispositionStatus(selectedStatus);
        setIsDispositionSelected(!!selectedStatus);
    };
    const handleHangup = () => {



        setCallStatus('ended');
        setWebphone(false)
        const payload = {
            "station": station,
            "phone_number": callernumber,
            "tenant_id": tenantid,
            "entity_type": entity_type,
            "user_id": user_id,
            "entity_id": entity_id,
            "agent": { "identity": "user", "value": user_name1 },
            "call_status": dispositionStatus,
            "description": callNotes,
            "profile_id": profileIdRef.current,
            "call_token": callTokenRef.current,
            "agent_id": agentIdRef.current,
        }

        console.log('payload responseeeeeeee',payload)

        dispatch(Hangup(payload))
            .then((disporesponse) => {
                if (disporesponse.status === 200) {

                        localStorage.removeItem('callerinfo')

                    response.terminate();

                }


            })
            .catch((err) => {
                return err
            });



        resetCallDuration();
        setCallNotes("");
        setDispositionStatus("");

    };
    
    const getconfigdata = localStorage.getItem('config')
    const getconfig = JSON.parse(getconfigdata)
    let webrtcdomain = getconfig.projects[0].config[0].webrtc_domain
    let webrtc_ip = getconfig.projects[0].config[0].webrtc_ip
    let webrtc_station = getconfig.projects[0].userInfo[0].user_phone_number
    let user_id = getconfig.projects[0].userInfo[0].user_id

   const webrtc = async () => {
        // let station2 = '7358846062'


        console.log('webrtc_station=====================>', webrtc_station);

        localStorage.setItem('resume', JSON.stringify(true))
        let webrtcSocket = new JsSIP.WebSocketInterface(`wss://${webrtcdomain}/ws`);
        var configuration = {
            sockets: [webrtcSocket],
            display_name: webrtc_station,
            authorization_user: webrtc_station,
            uri: `sip:${webrtc_station}@${webrtc_ip}`,
            password: webrtc_station,
            realm: webrtc_ip,
            DtlsSrtpKeyAgreement: false,
            contact_uri: `sip:${webrtc_station}@${webrtc_ip}`,
            connection_recovery_min_interval: 5,
            connection_recovery_max_interval: 20,
            use_preloaded_route: true,
            session_timers: false,
            no_answer_timeout: 60000,
            register_expires: 30000000,
            ws_servers: `wss://${webrtc_ip}/ws`,
            trace_sip: true,
        };
        var coolPhone = new JsSIP.UA(configuration);

        coolPhone.start();
        setPhone(coolPhone);

        coolPhone.register();

        coolPhone.on('registered', function (e) {

            console.log(e, 'registered', '============>');
            // toast.success('Sip Registered!');
        });

        coolPhone.on('unregistered', function (e) {
            // toast.error('Sip UnRegistered!');
            console.log(e, 'unregistered', '============>');

        });

        coolPhone.on('registrationFailed', function (e) {
            toast.error('Sip registrationFailed');
            console.log(e, 'registrationFailed', '============>');

        });

        coolPhone.on('connected', function (e) {
            // toast.success('Sip Connected!');
            setSipconnected(true);
            console.log(e, 'connected', '============>');
      
            setBadge('Online')

        });

        coolPhone.on('disconnected', function (e) {
            toast.error(' Disconnected');
            console.log(e, 'disconnected', '============>');

        });



        coolPhone.on('newRTCSession', function (e) {
            const session = e.session;
            dispatch(setSession(session));


            session.on('ended', function (data) {
                toast.error('Call Ended!');
                dispatch(rtcprocess(false))
                dispatch(rtcended(true))
                dispatch(setshowcalllogpage(true))
                dispatch(setagentstatus(false))
                setCallended(false)
                setWebphone(false)
                setCallStatus('ended');
                setLeadName(leadname)
                setcallername(callername)
                setStarttimer(false)
                handleHangup();
                // setIncomingdetails(false)
                resetCallDuration();
                console.log("session Ended==============>");
            });
            session.on('hold', function (data) {
                // The call has been placed on hold

            });

            session.on('failed', function (data) {
                console.log("Failed==========>", data);
                toast.error('Call Failed!');
                ringtoneRef.current.pause();
                ringtoneRef.current.currentTime = 0;
                // dispatch(rtcprocess(false))
                // dispatch(rtcended(true))
                dispatch(setagentstatus(false))
                dispatch(setshowcalllogpage(true))
                setIncomingscreen(false)
                setIncomingdetails(false);
                setLeadName(leadname)
                resetCallDuration();
                setWebphone(false)
               });

            setResponse(session)
            // dispatch(setSession(session));
            session.on('progress', function (e) {
                console.log('Progress...', e);
                toast.success('Call Progress !');
                dispatch(rtcprocess(true))
                dispatch(setshowcalllogpage(false))
                setShowDialpad(false)
                dispatch(setagentstatus(true)) //based on oncall notshow the icon
                dispatch(rtcended(false))
                setStarttimer(true)
                startCallDuration();
                setCallended(true)
                });

            // Determine if it's an incoming or outgoing call
            if (session.direction === 'outgoing') {
                // Handle outgoing call

                console.log('Outgoing call initiated to:');
            }
            else if (session.direction === 'incoming') {
                console.log('session.direction======================>', session);
                let callee_number = session._request.from.uri.user;
               const headers = session._request.headers;
                let header_context = headers['Caller-Number']?.[0]?.raw
                 setCallernumber("111111111111111111")


                let profile_id = headers['Profile-Id']?.[0]?.raw;
                let call_token = headers['Call-Token']?.[0]?.raw;
                let agent_id = headers['Agent-Id']?.[0]?.raw;

                //  setAgentId(agent_id);
                //  setCallToken(call_token);
                //  setProfileId(profile_id);
                profileIdRef.current = profile_id;
                callTokenRef.current = call_token;
                agentIdRef.current = agent_id;

                 
                console.log(header_context, 'header_context=================>',callee_number);
                
                setCallStatus('oncall');


               
                const call_type = headers['Call-Info'][0].raw
                const cleanCallType = call_type.substring(3);
                const outbount_type = call_type.substring(16);

                if (cleanCallType === 'inbound') {
                    
                   
                    setInboundcall(true)


                    ringtoneRef.current.loop = true;
                    ringtoneRef.current.play();
                    
                    if (Notification.permission === "granted") {
                        new Notification("Incoming Call", {
                            body: "You have an incoming call from" + callee_number ,
                            icon: favicon
                        });
                    }
                    
                    const countryCode = '+91';

                    let split_code = callee_number.replace(countryCode, '');

                    setCallernumber(split_code)
                    const data = {
                        type: "Ringing" 
                    }
                   
                    window.parent.postMessage(data, '*');

                    // window.postMessage({   data: data });  



                    let caller_insight = {
                        ticket_number: split_code
                    }
                  
                    dispatch(setCallerInsights(caller_insight));
                    setIncomingscreen(true)
                    setIncominganswer(session)

                       

                    // setInboundnumber(split_code);


                }
                if (outbount_type === 'manual') {
                    setWebphone(true);
                    console.log("Auto Answer Condition");
                    setInboundcall(false)

                 let caller_insight = {
                        ticket_number: header_context
                    }
                  
                    dispatch(setCallerInsights(caller_insight));
                console.log("InboundCall Dial Plan=========>", headers);
                    setTimeout(function () {
                        session.answer(sipOptions)
                    }, 500)

                }
                else {
                    console.log("Auto Answer Failed");

                }

                session.on('peerconnection', function (data) {
                    data.peerconnection.addEventListener('addstream', function (e) {
                        let remoteAudio = document.createElement('audio')
                        remoteAudio.srcObject = e.stream
                        remoteAudio.play()

                        // sound(false)
                    })
                })
            }
        });

    }




    const startCallDuration = () => {
        if (!callStartTime) {
            setCallStartTime(new Date());
        }
    };
    const resetCallDuration = () => {
        setCallStartTime(null);
        setCallDuration(0);
    };

    useEffect(() => {

        window.addEventListener('message', incomingresponse);

    }, [])

    const incomingresponse = async (event) => {

        let inboundlead_name = event.data.lead_name
        if (inboundlead_name) {
            // setcallername(inboundlead_name)
            setLeadName(inboundlead_name)
            setcallername(inboundlead_name)
        }



    }
    // useEffect(() => {
    //     fetchDispo();
    // }, [])

    useEffect(() => {
        const crmname = localStorage.getItem('config')
        const crmowner_name = JSON.parse(crmname).projects[0].userInfo[0].user_name
        if (callername == "" || callername == null || callername == undefined) {
            setcallername("Unkown Name")
        }
        setcrmownername(crmowner_name)
        if (callStartTime) {
            const timer = setInterval(() => {
                const currentTime = new Date();
                const durationInSeconds = Math.floor((currentTime - callStartTime) / 1000);
                setCallDuration(durationInSeconds);
            }, 1000);

            return () => {
                clearInterval(timer);
            };
        }

        window.addEventListener('message', handleMessageWithDelay);
        return () => {
            console.log("Removelistener")
            window.removeEventListener('message', handleMessageWithDelay);
        };


    }, [callStartTime]);

    const handleMessageWithDelay = (event) => {
        setTimeout(() => handleMessage(event), 2000);
    }

    const handleMessage = async (event) => {
        try {
            
            console.log("C2C Event Data:",event.data);
            const api_domain = JSON.parse(localStorage.getItem('token'))
            const apiToken = api_domain.access_token;
            const stationnumber = webrtc_station
            // const lead_id1 = event.data.data.id
            const module = "Leads"
            const entity_number = event.data.data.number


            let caller_insight = {
                ticket_number: entity_number,
                lead_id:event.data.data.lead_id
            }

            dispatch(setCallerInsights(caller_insight));

            const countryCode = '+91';
            let ob_split_code
            
            if (entity_number !== null && entity_number !== undefined) {
                 ob_split_code = entity_number.replace(countryCode, '');
            }
          

            console.log("entity_numberentity_number",sipconnected);
             
            if (event.data.data.number !== null && event.data.data.number !== undefined  ) {




                const payload = {
                    station: stationnumber,
                    phone_number: event.data.data.number,
                    campaign: "Dialer",
                    agent: {
                        identity: 'user',
                        value: user_name1,
                    },
                    custdata: {
                        lead_id: event.data.data.lead_id,
                        module: module,

                    },
                };
                console.log("Payloaddddddd",payload);


                dispatch(MakeManualcall(payload)).then((callresponse) => {
                    if (callresponse.status === 200) {
                       localStorage.setItem('callstatus', JSON.stringify(response.status));
                       toast.success('Call Initiated!');
                    //    setWebphone(true)
                        

                    }
                    else {
                        toast.error('Call Not Initiated! Check Agent Status')
                    }


                })
                    .catch((err) => {
                        if (err.response.status == 401) {
                            localStorage.removeItem('login');
                            localStorage.removeItem('hanguppayload');
                            localStorage.removeItem('resume');
                            localStorage.removeItem('agentstatus');
                            localStorage.removeItem('config');
                            localStorage.removeItem('username');
                            localStorage.removeItem('apinfo');
                            localStorage.removeItem('token');
                            localStorage.removeItem('callstatus');
                            localStorage.removeItem('queuelogin');
                         
                            localStorage.removeItem('entititytype');
                            localStorage.removeItem('station');
                            window.location.href = `/`;

                        }
                        else {
                            // setPause(true)
                            toast.error('Call Not Initiated! Check Agent Status')
                        }
                        localStorage.setItem('callstatus', JSON.stringify(err.response.status));

                       return err
                       
                    });



            }






        }

        catch (error) {
            console.error('Error making call:', error);
        }




    };

    const answercall = async () => {
        incominganswer.answer(sipOptions)
        setIncomingdetails(true);
        setIncomingscreen(false);
        setWebphone(true);

        const createpayload = {
            "phone_number": callernumber,
            "agent_id": user_id,
            "type": "Ticket Create"
        }


        dispatch(CreateTicket(createpayload)).then((createresponse) => {
           
            if (createresponse.status === 200) {

              


            }


        })
            .catch((err) => {
              return err
            });



        ringtoneRef.current.pause();
        ringtoneRef.current.currentTime = 0;
    }

    const declinecall = async () => {
        ringtoneRef.current.pause();
        ringtoneRef.current.currentTime = 0;
        incominganswer.terminate({
            status_code: 603,
            reason_phrase: 'Decline',
        });



    }






    function toggleUserOptions() {
        const userOptions = document.getElementById('userOptions');
        userOptions.style.display = userOptions.style.display === 'block' ? 'none' : 'block';
    }
    function logout() {
        try {
            const logutpayload = {
                user: user_name1,
                station: station
            }
            // dispatch(Logout(logutpayload))


            dispatch(Logout(logutpayload)).then((response) => {

                if (response.status === 200) {

                    forcelogout();



                }

            }).catch((err) => {
                if (err.response.status == 400) {
                    forcelogout()
                }
                return err
            })


        } catch (error) {
            return (error)

        }


    }



    function HandleSetBadge(badge) {
        console.log('Selected status:', badge);

        const userOptions = document.getElementById('userOptions');
        userOptions.style.display = 'none';
        if (badge == "Online") {
            setBadge('Online')
            setPause(false)
            const agentname = localStorage.getItem("username")
            const payload = {
                "user": agentname,
                "campaign": "Dialer",
            }
            dispatch(Resume(payload)).then((resumeresponse) => {
                if (resumeresponse.status == 200) {
                    localStorage.setItem('agentstatus', true)

                    webrtc();

                }
            }).catch((err) => {

                if (err.response.status == 400) {
                    forcelogout()
                }
                return err
            })




        }
        else if (badge == "Away") {
            setBadge('Away')
            setAwayOptionsOpen(true);
            // localStorage.setItem('agentstatus', false)
            // unregisterWebRTC();

        } else if (badge == "Offline") {
            setBadge('Offline')
            localStorage.removeItem('agentstatus');
            const agentname = localStorage.getItem("username")
            const payload = {
                "user": agentname,
                "reason": "Break"
            }


        }
        else {
         
            setAwayOptionsOpen(false);
            const agentname = localStorage.getItem("username")
            const payload = {
                "user": agentname,
                "reason": badge,
                "campaign": "Dialer",
            }
            dispatch(Pause(payload)).then((pauseresponse) => {

                if (pauseresponse.status == 200) {
                    localStorage.setItem('agentstatus', false)
                    unregisterWebRTC();
                }
            }).catch((err) => {
                if (err.response.status == 400) {
                    forcelogout()
                }
                return err
            })

        }
    }







    return (


        <div style={{ filter: navigator.onLine ? '' : 'blur(5px)' }} >
            <Comtemplete
                toggleUserOptions={toggleUserOptions}
                badge={badge}
                logout={logout}
                handleSetBadge={HandleSetBadge}
                awayOptionsOpen={awayOptionsOpen}
            >

                <div className='home-container' >
                    <div className='left-container'>

                        <div>
                            {webphone ?
                        (
                          <Webphone/>     
                             )

                                : pause ? (
                                    <div>
                                    <div id="top" class="page-wrap">

                                            <div className="agent-pause">
                                                <img class="pause-illust" src={pausewave}></img>
                                                <div className="pause-notes">User is offline</div>

                                            </div>
                                        </div>
                             </div>
                                ) : incomingscreen ? (
                                    <div>

                                        <Incomingcallscreen
                                            onAnswer={answercall}
                                            onDecline={declinecall}
                                            leadname={"Pandi"}

                                            leaddate={ibleaddate}
                                            leadowner={"Pandi"}
                                        />
                                    </div>
                                ) : backgroundstate.setshowcalllogpage ? (
                                    <div>


                                        <div id="top" class="page-wrap">

                                            <CallLog />


                                        </div>



                                    </div>

                                ) :

                                    <div></div>

                            }
                            {showDialpad && <Dialpad />}

                            {(showCallLog || showDialpad) && (
                                <button className="dial-button" onClick={toggleDialpad}>
                                    <FontAwesomeIcon style={{ color: '#fff', fontSize: '15px', textAlign: 'center' }} icon={iconType} />
                                </button>
                            )}

                            {/* 
            <button className="dial-button" onClick={toggleDialpad}>
                <FontAwesomeIcon style={{ color: '#fff', fontSize: '15px', textAlign: 'center' }} icon={iconType} />
            </button> */}

                        </div>


                    </div>
                    <div className='right-container'> 
                        {/* <img className='home-right-illu' src={rightillu}> </img> */}
                        <img class="home-right-illu" src={rightillu}></img>
                        {/* <div>Pandiiiiissiiiiiiiiiiiiiiiiiiiii123i</div> */}
                    </div>
                </div>
            </Comtemplete>
        </div>
    );

}

export default Homepage;